// Scheduler colour coding. Appointment types are free text from the EMR
// ("In Three Months", "US Abdomen", "NEW PATIENT", ...), so each one is put in
// a legend category by its wording; anything unrecognised is "Other".
export const CATEGORIES = [
  { key: "followup", label: "Follow up", color: "#1d2951", tint: "#eef1f8" },
  { key: "new", label: "New patient", color: "#2a9d8f", tint: "#e8f6f3" },
  { key: "wellness", label: "Annual wellness", color: "#2e9e5b", tint: "#e9f6ee" },
  { key: "procedure", label: "Procedure", color: "#5b5fc7", tint: "#efeffb" },
  { key: "tele", label: "Telehealth", color: "#3b82c4", tint: "#ebf3fb" },
  { key: "lab", label: "Lab review", color: "#9b51e0", tint: "#f5eefc" },
  { key: "other", label: "Other", color: "#8a94a6", tint: "#f2f4f7" },
];
const BY_KEY = Object.fromEntries(CATEGORIES.map((c) => [c.key, c]));

const RULES = [
  ["tele", /tele|video|virtual/i],
  ["new", /new\s*pat|^new\b|\bnp\b/i],
  ["wellness", /wellness|annual|\bawv\b|physical|preventive/i],
  ["lab", /\blab/i],
  ["procedure", /procedure|\bus\b|ultra\s*sound|echo|scan|estim|cimt|allergy|\bcca\b|biat|ekg|ecg|abdomen|thyroid|carotid|pulse|shape|retino|injection|test|doppler|x-?ray|mri|\bct\b|biopsy/i],
  ["followup", /follow|month|week|year|recheck|f\/u|visit|office/i],
];

export const categoryOf = (type) => {
  const t = String(type || "");
  for (const [key, re] of RULES) if (re.test(t)) return BY_KEY[key];
  return BY_KEY.other;
};

// Cancelled and no-show visits are drawn striped and struck through.
export const isCancelled = (appt) =>
  /cancel|no[\s-]?show/i.test(String(appt?.visit_confirmation || ""));

// Sentence-case a type for display ("IN THREE MONTHS" -> "In three months").
export const prettyType = (type) => {
  const t = String(type || "").trim();
  if (!t) return "";
  return t === t.toUpperCase() ? t.charAt(0) + t.slice(1).toLowerCase() : t;
};

export const initialsOf = (name) =>
  String(name || "")
    .replace(/^dr\.?\s+/i, "D ")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");

// "09:30:00" -> minutes since midnight
export const minutesOf = (hhmmss) => {
  const [h, m] = String(hhmmss || "0:0").split(":").map(Number);
  return (h || 0) * 60 + (m || 0);
};
